<div class="row ml-2 mr-2">
    <kendo-grid [data]="viewBillableItems.gridData" [loading]="viewBillableItems.loading"
        [pageable]="billablesCount > viewBillableItems.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
        [pageSize]="viewBillableItems.state.take" [skip]="viewBillableItems.state.skip" [sortable]="true"
        [sort]="viewBillableItems.state.sort" [filterable]="false" [filter]="viewBillableItems.state.filter"
        [groupable]="false" [selectable]="{mode: 'single'}" [columnMenu]="false" [resizable]="true"
        [reorderable]="false" [kendoGridSelectBy]="'id'">
        <!--Units-->
        <kendo-grid-column field="units" title="{{ 'UNITS' | translate }}" [width]="30" class="text-right"
            filter="numeric">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngStyle]="((dataItem.adjustmentStatus === 'VOID_BY_ADJUSTMENT' && dataItem.units < 0) || (dataItem.adjustmentStatus === 'VOID')) ? {'color': '#dc5d3f', 'font-weight': 'bold'} : {'color': 'green', 'font-weight': 'bold'}">{{dataItem.units}}</span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <div [formGroup]="caseBillableFormGroup">
                    <kendo-numerictextbox [format]="'n0'" formControlName="units" [min]="1" style="max-width:150px">
                    </kendo-numerictextbox>
                </div>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                </kendo-grid-numeric-filter-cell>
            </ng-template>
        </kendo-grid-column>
        <!--Rate-->
        <kendo-grid-column field="rate" title="{{ 'RATE' | translate }}" [width]="30" [filterable]="true"
            [sortable]="true" [format]="'n2'" class="text-right" filter="numeric">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <div [ngSwitch]="!dataItem.billableServiceHasManualAmount">
                    <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                        <kendo-numerictextbox [format]="'n2'" formControlName="rate" [min]="0" style="max-width:150px">
                        </kendo-numerictextbox>
                    </div>
                </div>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                </kendo-grid-numeric-filter-cell>
            </ng-template>
        </kendo-grid-column>
        <!--Amount-->
        <kendo-grid-column field="amount" title="{{ 'BILLED-AMOUNT' | translate }}" [width]="40" [format]="'n2'"
            class="text-right" filter="numeric">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span [ngStyle]="((dataItem.adjustmentStatus === 'VOID_BY_ADJUSTMENT' && dataItem.amount < 0) || (dataItem.adjustmentStatus === 'VOID')) ? {'color': '#dc5d3f', 'font-weight': 'bold'} : {'color': 'green', 'font-weight': 'bold'}">{{dataItem.amount | number : '1.2-2'}}</span>                
            </ng-template>
            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                <div [ngSwitch]="dataItem.billableServiceHasManualAmount">
                    <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                        <kendo-numerictextbox [format]="'n2'" formControlName="amount" [min]="0"
                            style="max-width:150px">
                        </kendo-numerictextbox>
                    </div>
                </div>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                </kendo-grid-numeric-filter-cell>
            </ng-template>
        </kendo-grid-column>
        <!--Diagnoses-->
        <kendo-grid-column field="diagnoses" title="{{ 'DIAGNOSES' | translate }}" [width]="40" [filterable]="true"
            [sortable]="true">
        </kendo-grid-column>
        <!--Adjustment reason-->
        <kendo-grid-column field="adjustmentReason" title="{{ 'ADJUSTMENT-REASON' | translate }}" [width]="30"
            [filterable]="true" [sortable]="true">
        </kendo-grid-column>
        <!--Adjustment date-->
        <kendo-grid-column field="adjustmentDate" title="{{ 'ADJUSTMENT-DATE' | translate }}" [width]="30" filter="date"
            format="{0:d}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem.adjustmentDate !== null && dataItem.adjustmentDate !== undefined"
                    class="text-center">
                    {{ intl.formatDate(intl.parseDate(dataItem.adjustmentDate), "d") }}
                </div>
            </ng-template>
        </kendo-grid-column>
        <!--Adjustment Status-->
        <kendo-grid-column field="adjustmentStatus" title="{{ 'ADJUSTMENT-TYPE' | translate }}" [width]="30"
            [filterable]="true" [sortable]="true">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="text-center">
                    {{getAdjustmentTypeText(dataItem.adjustmentStatus)}}
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>